export const ERROR_PROJECT_LIST_TITLE = "platform.alerts.noDataToFetch.title";
export const ERROR_PROJECT_LIST_DESCRIPTION = "activation.home.projects.list.error.description";

export const EMPTY_PROJECT_LIST_TITLE = "activation.home.projects.list.empty.title";
export const EMPTY_PROJECT_LIST_DESCRIPTION = "activation.home.projects.list.empty.description";
